export default {
    name: 'Loading',
    props: {
      positionAbsolute: {
        default: false,
        type: Boolean
      }
    }
  }